module.exports = __webpack_public_path__ + "img/sx-1.b25dfd89.png";